// extracted by mini-css-extract-plugin
export default {"FloorAreaBody":"styles_FloorAreaBody__Voujj","title":"styles_title__xYc8x","selected":"styles_selected__+2mgJ"};